import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Label } from '../../component-label';
import { forwardRef } from 'react';
export const AvatarText = forwardRef(({ size, variant, ...props }, ref) => (_jsx(Label, { as: "span", size: size, color: variant === 'default' ? 'surface-onBase-100' : 'surface-onBase-900', ...props, ref: ref })));
AvatarText.displayName = 'AvatarText';
